import styled from 'styled-components'
import breakpoint from '../../utils/breakpoint'

const {mobile, desk, xs, sm, md, lg, xl, xxl} = breakpoint

export const Box = styled.div`
  // opacity: ${({pastEvent}) => (pastEvent ? '0.55' : '1')};
`
//
export const LinkBox = styled.div`
  display: flex;
`

//
// export const WidthBox = styled(Box)`
//   width: ${({ratio}) => `${ratio * 100}%`};
// `
